import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';
import { Modal, Form, Input, Col, Row, Empty, Spin, message } from 'antd';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { AtbdTopDropdwon } from '../../../components/utilities/auth-info/auth-info-style';
import { getAllMyTemplates, getAllSharedTemplates } from '../../../Api/Services/EmailApiSevices';

const Popup = ({ openTemplate, setOpenTemplate, setTemplateId, entityName }) => {
    const [templates, setTemplates] = useState()
    const [search, setSearch] = useState([])
    const [searchText, setSearchText] = useState()
    const [entityType] = useState(entityName ? (entityName === "Deals" ? "Contacts" : entityName === "Tasks" ? "Users" : entityName) : "ALL")
    const { rtl } = useSelector(state => {
        return {
            rtl: state.ChangeLayoutMode.rtlData,
        };
    });
    const handleClose = () => {
        setOpenTemplate(false);
    }
    async function getAllTemplate() {
        try {
            const [
                response,
                response2,
            ] = await Promise.all([
                getAllMyTemplates(),
                getAllSharedTemplates(),
            ]);
            const allTemplates = [...response, ...response2];
            setTemplates(allTemplates)
            setSearch(allTemplates)
        }
        catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        getAllTemplate()
    }, [])
    const filterData = (data) => {
        let filteredData = [...data];
        if (searchText) {
            filteredData = filteredData.filter(item => {
                const searchableFields = [
                    item.templateName,
                ];
                return searchableFields.some(field =>
                    field && field.toString().toUpperCase().includes(searchText.toUpperCase())
                );
            });
        }
        if (entityType !== "ALL") {
            if (entityType) {
                filteredData = filteredData.filter(item => item.entityType === entityType);
            }
        }
        return filteredData;
    };
    const applyFilters = () => {
        const filteredData = filterData(search);
        setTemplates(filteredData);
    };
    useEffect(() => {
        if (templates) {
            applyFilters();
        }
    }, [searchText, entityType, search])
    function renderThumb({ style, ...props }) {
        const thumbStyle = {
            borderRadius: 6,
            backgroundColor: '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
    }
    const renderTrackVertical = () => {
        const thumbStyle = {
            position: 'absolute',
            width: '6px',
            transition: 'opacity 200ms ease 0s',
            opacity: 0,
            [rtl ? 'left' : 'right']: '2px',
            bottom: '2px',
            top: '2px',
            borderRadius: '3px',
        };
        return <div className="hello" style={thumbStyle} />;
    };
    function renderView({ style, ...props }) {
        const customStyle = {
            marginRight: rtl && 'auto',
            [rtl ? 'marginLeft' : 'marginRight']: '-17px',
        };
        return <div {...props} style={{ ...style, ...customStyle }} />;
    }
    renderThumb.propTypes = {
        style: PropTypes.shape(PropTypes.object),
    };
    renderView.propTypes = {
        style: PropTypes.shape(PropTypes.object),
    };
    const templateClick = (value) => {
        setTemplateId({ id: value, key: Date.now() })
        if (value) {
            setOpenTemplate(false)
        }
    }
    return (
        <>
            <Modal
                title="Select Template"
                open={openTemplate}
                onCancel={handleClose}
                maskClosable={false}
                footer={null}
                width={700}
            >
                <AddUser>
                    <div className="user-info-form" style={{ padding: "0px 20px" }}>
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }}>
                                <Row gutter={30} style={{ marginBottom: 30 }}>
                                    {/* <Col span={7}>
                                        <Form.Item >
                                            <Select style={{ width: '100%' }} value={entityType} disabled={entityType !== "All"} onChange={(value) => setEntityType(value)}>
                                                <Option value="ALL">All</Option>
                                                <Option value="Leads">Leads</Option>
                                                <Option value="Contacts">Contacts</Option>
                                                <Option value="Users">Users</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> */}
                                    <Col span={24}>
                                        <Form.Item >
                                            <Input addonBefore={<SearchOutlined />} placeholder='Search Template' onChange={(e) => setSearchText(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            {templates ?
                                <AtbdTopDropdwon className="atbd-top-dropdwon nav" style={{ width: "100%" }}>
                                    <Scrollbars
                                        autoHeight
                                        autoHide
                                        renderThumbVertical={renderThumb}
                                        renderView={renderView}
                                        renderTrackVertical={renderTrackVertical}
                                    >
                                        <ul className="atbd-top-dropdwon__nav notification-list">
                                            {templates.length === 0 ?
                                                <Empty />
                                                : templates.map((item) => {
                                                    return (
                                                        <li key={item.templateId}>
                                                            <div
                                                                className='table_list_click'
                                                                role="button"
                                                                tabIndex={0}
                                                                onClick={() => templateClick(item.templateId)}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                        templateClick(item.templateId)
                                                                    }
                                                                }}
                                                                style={{ borderBottom: "1px solid #e1e1e1" }}

                                                            >
                                                                <div className="atbd-top-dropdwon__content notifications" style={{ margin: "10px 0px" }}>
                                                                    <FeatherIcon icon="star" size={18} style={{ color: "gray" }} />
                                                                    <span style={{
                                                                        marginTop: "-2px",
                                                                        marginLeft: "10px",
                                                                        fontWeight: "bold"
                                                                    }}
                                                                    >
                                                                        {item.templateName}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </Scrollbars>
                                </AtbdTopDropdwon>
                                : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                                    <Spin />
                                </div>}
                        </BasicFormWrapper>
                    </div>
                </AddUser>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    openTemplate: PropTypes.bool.isRequired,
    setOpenTemplate: PropTypes.func.isRequired,
    setTemplateId: PropTypes.object.isRequired,
    entityName: PropTypes.string.isRequired,
};

export default Popup;
